@if (section(); as s) {
  <app-section-wrapper [id]="s.id" [title]="s.title" [background]="s.background">
    <div class="cards-grid stagger">
      @for (feature of s.items; track feature.title) {
        <app-feature-card
          [icon]="feature.icon"
          [title]="feature.title"
          [description]="feature.description"
        />
      }
    </div>
  </app-section-wrapper>
}
